import { Component, Input, OnInit, output, input, ChangeDetectionStrategy } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MaterialModule } from '../../material.module';
import { JkfieldlabelComponent } from '../jkfieldlabel/jkfieldlabel.component';
import { CommonModule } from '@angular/common';
import { JkBaseComponent } from '../jkbase/jkbase.component';



@Component({
    selector: 'app-jktextarea',
    templateUrl: './jktextarea.component.html',
    styleUrls: [],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MaterialModule,JkfieldlabelComponent,CommonModule,MatFormFieldModule],
})
export class JktextareaComponent extends JkBaseComponent  implements OnInit {
  override comType: string = 'jktextarea';
  stylingMode = 'outlined';
  readonly autocomplete = input(false);
  //@Input() labelMode = 'floating';
  readonly maxlength = input(4000);
  readonly autoGrow = input(true);
  readonly counter = input(true);
  readonly labelPlacement = input('floating'); // "end" ｜ "fixed" ｜ "floating" ｜ "stacked" ｜ "start"
  readonly helperText = input('');
  readonly rows = input<number>(0);
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() value: string = '';
  readonly valueChange = output<any>();
  onValueChange(newValue: any) {
    //console.log('jkTextArea onValueChange:'+newValue.target.value);
    this.value = newValue.target.value;
    this.valueChange.emit(this.value);
  }
  readonly autoResizeEnabled = input<boolean>(true);
  _readOnly: boolean = false;
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input() set readOnly(value:boolean){
    this._readOnly = value;
    if(value){
      this.stylingMode = 'filled';
    }else{
      this.stylingMode = 'outlined';
    }
  };
  _minHeight: number = 30;
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input() set minHeight(value){
    this._minHeight = value;
  };
  get minHeight(): number{
    // if(this.state === entityState.dsBrowse){
    //   return undefined;
    // }else{
    //   return this._minHeight;
    // }
    return this._minHeight;
  }
  _maxHeight: number = 300;
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input() set maxHeight(value:number){
    this._maxHeight = value;
  };
  get maxHeight(): number{
    // if(this.state === entityState.dsBrowse){
    //   return undefined;
    // }else{
    //   return this._maxHeight;
    // }
    return this._maxHeight;
  }
  //@Input()  width: string = '100%';
  readonly height = input<string>('auto'); //'70px'; // 100%
  //@Input() titleStyle: string = 'font-size: 12px; color: black;';
  constructor() {
    super();
   }

  override ngOnInit() {
    super.ngOnInit();
    //this.state = this._state;
  }

}
